export var codeExpiredErrorMessageKey = 'two_fa_settings.code_expired_error_message';
